import React from 'react';
// import styled from 'styled-components';
import { InputSearch as KrispyInputSearch } from '@krispy/inputs/web';

type Props = $ReadOnly<{|
    /**
     * Text label for input overall
     */
    label?: string,
|}>

const InputSearch = (props: Props): React$Node => (
  <>
    <KrispyInputSearch {...props} />
  </>
);

export default InputSearch;
